import styles from './email-log-renderer.module.scss';
import { Col, Row } from 'reactstrap';
import { Box, Container, Froala } from '@frontend-workspace/react-shared-lib';
import { IEmailLogPeriod } from 'libs/webkua-lib/src/lib/_models/email-log-period';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EmailLogRendererProps {
  data: IEmailLogPeriod
}

export function EmailLogRenderer(props: EmailLogRendererProps) {
  const { t } = useTranslation();

  return (<>
    {props.data.htmlBody &&
      <Box sx={{ padding: '20px 0' }}>
        <Container
          className='container-fluid'
          maxWidth={false}>
          <Row>
            <Col>
              <div className='mb-3'>
                <label className='mb-1'>{t('standard.email')}</label>
                <Froala
                  maxHeight={800}
                  model={props.data.htmlBody}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Box>
    }
  </>);
}

export default EmailLogRenderer;
